<template>
  <div class="lucky-page lucky-reference-home">
    <headerSection></headerSection>
    <button v-if="adminTip.enabled" type="button" class="admin-tip-floating-button" @click="openAdminTipPopup" aria-label="ทิปแอดมิน">
      <i class="fas fa-hand-holding-heart"></i>
      <span>ทิป</span>
    </button>

    <div id="main__content" class="">
      <div class="x-main-container">
        <div class="x-main-content">
          <!-- 'height':'100vh'-->
          <!-- background-size: cover;
    background-attachment: fixed;
    background-position: center; -->
          <section
            class="x-index-top-container"
            :style="{ 'background-image': `url(${require('../assets/images/Shiba-BG.jpg')})`,'background-size':'cover','background-attachment':'fixed','background-position':'center'}"
          >
            <div class="x-wrapper-right-container"></div>
            <div class="-index-inner-wrapper">
              <div class="-heading-wrapper js-replace-heading-wrapper">
                <h1 class="-title">
                  {{ $t('system_title') }}
                </h1>
              </div>
              <swiper
                v-if="banners && banners.length"
                ref="mySwiper"
                :options="swiperOptions"
                class="lucky-home-banner-swiper"
                style="padding-top:10px;padding-left:10px;padding-right:10px;"
              >
                <swiper-slide v-for="(item,index) in banners" :key="index" class="lucky-home-banner-slide">
                  <img
                    class="img-fluid -slick-item -item-1 lucky-home-banner-image"
                    :alt="item.name"
                    width="800"
                    height="288"
                    :src="item.image"
                /></swiper-slide>
                <!-- <div class="swiper-pagination" slot="pagination"></div> -->
              </swiper>
              <div class="d-lg-none" style="padding-top:10px;">
                <div class="x-feed-news-header">
                  <div
                    class="-feed-news-inner-wrapper animated fadeInUp"
                    data-animatable="fadeInUp"
                    data-delat="200"
                  >
                    <div class="-icon-container">
                      <i class="fas fa-volume-up"></i>
                    </div>

                    <div class="-track">
                      <div class="-track-item -duration-normal-content">
                        .. {{ $t('welcome_message') }}
                        ..
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div class="-games-provider-wrapper">
                <div class="-games-index-page">
                  <div
                    class="x-category-provider js-game-scroll-container js-game-container"
                  >
                    <div class="-top-paragraph">
                      <div class="container">
                        <div class="row">
                          <div class="col-12 px-2 px-lg-3">
                           <img src="../assets/images/title-shiba.png" :alt="$t('img_title')" style="width: 100%;max-width: 800px;height: auto;">
                          </div>
                        </div>
                      </div>
                    </div>

                    <div class="-games-list-container container">
                      <nav class="nav-menu" id="navbarProvider">
                        <ul class="nav nav-pills">
                          <!-- <li
                            class="nav-item -random-container -game-slot-macro-container "
                          >
                          <router-link to="/play" class="nav-link js-account-approve-aware">
                              <picture>
                                <img
                                  src="../assets/images/menu/Menu-11.png"
                                  alt="สุ่มเล่นสกิลเกมบนเว็บ time2lucky คาสิโน บาคาร่าสดออนไลน์"
                                  class="img-fluid -img-provider lazyload"
                                />
                              </picture>
                            </router-link>
                          </li>

                          <li
                            class="nav-item -random-container -game-slot-macro-container "
                          >
                            <a
                              href="javascript:void(0)"
                              class="nav-link js-account-approve-aware"
                              target="_blank"
                              rel="nofollow noopener"
                              data-toggle="modal"
						                  data-target="#depositModal"
                              @click="checkPromotions()"
                            >
                              <picture>
                                <img
                                  src="../assets/images/menu/Menu-01.png"
                                  alt="สุ่มเล่นสกิลเกมบนเว็บ time2lucky คาสิโน บาคาร่าสดออนไลน์"
                                  class="img-fluid -img-provider lazyload"
                                />
                              </picture>
                            </a>
                          </li>

                          <li
                            class="nav-item -random-container -game-slot-macro-container "
                          >
                            <a
                               href="javascript:void(0)"
                              class="nav-link js-account-approve-aware"
                              target="_blank"
                              data-toggle="modal"
						                  data-target="#withdrawModal"
                              @click="moveCreditToWallet()"
                            >
                              <picture>
                                <img
                                  src="../assets/images/menu/Menu-02.png"
                                  alt="สุ่มเล่นสกิลเกมบนเว็บ time2lucky คาสิโน บาคาร่าสดออนไลน์"
                                  class="img-fluid -img-provider lazyload"
                                />
                              </picture>
                            </a>
                          </li> -->
                          <li
                            class="nav-item -random-container -game-slot-macro-container  lucky-tile lucky-tile-promotion"
                          >
                            <router-link aria-label="โปรโมชั่น" to="/promotion" class="nav-link js-account-approve-aware">
                              <picture>
                                <img
                                  src="../assets/images/menu/mobile-menu-promotion.webp"
                                  alt="สุ่มเล่นสกิลเกมบนเว็บ time2lucky คาสิโน บาคาร่าสดออนไลน์"
                                  class="img-fluid -img-provider lazyload"
                                />
                              </picture>
                              <div class="-menu-text">{{ $t('menu_labels.promotion') }}</div>
                            </router-link>
                          </li>
                          <li
                            class="nav-item -random-container -game-slot-macro-container  lucky-tile lucky-tile-history"
                          >
                            <router-link aria-label="ธุรกรรม" to="/history" class="nav-link js-account-approve-aware">
                              <picture>
                                <img
                                  src="../assets/images/menu/mobile-menu-history.webp"
                                  alt="สุ่มเล่นสกิลเกมบนเว็บ time2lucky คาสิโน บาคาร่าสดออนไลน์"
                                  class="img-fluid -img-provider lazyload"
                                />
                              </picture>
                              <div class="-menu-text">{{ $t('menu_labels.transaction') }}</div>
                            </router-link>
                          </li>

                          <li
                            class="nav-item -random-container -game-slot-macro-container  lucky-tile lucky-tile-partner"
                          >
                            <router-link aria-label="รับทรัพย์" to="/partner" class="nav-link js-account-approve-aware">
                              <picture>
                                <template v-if="partner">
                                  <img
                                    src="../assets/images/menu/mobile-menu-partner.webp"
                                    alt="สุ่มเล่นสกิลเกมบนเว็บ time2lucky คาสิโน บาคาร่าสดออนไลน์"
                                    class="animate__animated animate__pulse animate__infinite img-fluid -img-provider lazyload"
                                  />
                                </template>
                                <template v-else>
                                  <img
                                    src="../assets/images/menu/mobile-menu-partner.webp"
                                    alt="สุ่มเล่นสกิลเกมบนเว็บ time2lucky คาสิโน บาคาร่าสดออนไลน์"
                                    class="img-fluid -img-provider lazyload"
                                  />
                                </template>
                              </picture>
                              <div class="-menu-text">{{ $t('menu_labels.partner_link') }}</div>
                            </router-link>
                          </li>

                          <li
                            class="nav-item -random-container -game-slot-macro-container  lucky-tile lucky-tile-continue"
                          >
                            <router-link aria-label="ฝากต่อเนื่อง" to="/continue" class="nav-link js-account-approve-aware">
                              <picture>
                                  <template v-if="continueCheck">
                                  <img
                                    src="../assets/images/menu/mobile-menu-continue.webp"
                                    alt="สุ่มเล่นสกิลเกมบนเว็บ time2lucky คาสิโน บาคาร่าสดออนไลน์"
                                    class="animate__animated animate__pulse animate__infinite img-fluid -img-provider lazyload"
                                  />
                                </template>
                                <template v-else>
                                  <img
                                    src="../assets/images/menu/mobile-menu-continue.webp"
                                    alt="สุ่มเล่นสกิลเกมบนเว็บ time2lucky คาสิโน บาคาร่าสดออนไลน์"
                                    class="img-fluid -img-provider lazyload"
                                  />
                                </template>
                              </picture>
                              <div class="-menu-text">{{ $t('menu_labels.deposit_continue') }}</div>
                            </router-link>
                          </li>

                          <li
                            class="nav-item -random-container -game-slot-macro-container  lucky-tile lucky-tile-cashback"
                          >
                            <router-link aria-label="คืนยอดเสีย" to="/cashback" class="nav-link js-account-approve-aware">
                              <picture>
                                <template v-if="cashback">
                                  <img
                                    src="../assets/images/menu/mobile-menu-cashback.webp"
                                    alt="สุ่มเล่นสกิลเกมบนเว็บ time2lucky คาสิโน บาคาร่าสดออนไลน์"
                                    class="animate__animated animate__pulse animate__infinite img-fluid -img-provider lazyload"
                                  />
                                </template>
                                <template v-else>
                                  <img
                                    src="../assets/images/menu/mobile-menu-cashback.webp"
                                    alt="สุ่มเล่นสกิลเกมบนเว็บ time2lucky คาสิโน บาคาร่าสดออนไลน์"
                                    class="img-fluid -img-provider lazyload"
                                  />
                                </template>
                              </picture>
                              <div class="-menu-text">{{ $t('menu_labels.cashback') }}</div>
                            </router-link>
                          </li>

                          <li
                            class="nav-item -random-container -game-slot-macro-container  lucky-tile lucky-tile-spin"
                          >
                            <router-link aria-label="วงล้อรับเหรียญ" to="/spin" class="nav-link js-account-approve-aware">
                              <picture>
                                <template v-if="spin">
                                  <img
                                    src="../assets/images/menu/mobile-menu-spin.webp"
                                    alt="สุ่มเล่นสกิลเกมบนเว็บ time2lucky คาสิโน บาคาร่าสดออนไลน์"
                                    class="animate__animated animate__pulse animate__infinite img-fluid -img-provider lazyload"
                                  />
                                </template>
                                <template v-else>
                                  <img
                                    src="../assets/images/menu/mobile-menu-spin.webp"
                                    alt="สุ่มเล่นสกิลเกมบนเว็บ time2lucky คาสิโน บาคาร่าสดออนไลน์"
                                    class="img-fluid -img-provider lazyload"
                                  />
                                </template>
                              </picture>
                              <div class="-menu-text">{{ $t('menu_labels.spin_wheel') }}</div>
                            </router-link>
                          </li>

                          <li
                            class="nav-item -random-container -game-slot-macro-container  lucky-tile lucky-tile-roulet"
                          >
                            <router-link aria-label="รูเล็ตรับเหรียญ" to="/roulet" class="nav-link js-account-approve-aware">
                              <picture>
                                <template v-if="roulet">
                                  <img
                                    src="../assets/images/menu/mobile-menu-roulette.webp"
                                    alt="สุ่มเล่นสกิลเกมบนเว็บ time2lucky คาสิโน บาคาร่าสดออนไลน์"
                                    class="animate__animated animate__pulse animate__infinite img-fluid -img-provider lazyload"
                                  />
                                </template>
                                <template v-else>
                                  <img
                                    src="../assets/images/menu/mobile-menu-roulette.webp"
                                    alt="สุ่มเล่นสกิลเกมบนเว็บ time2lucky คาสิโน บาคาร่าสดออนไลน์"
                                    class="img-fluid -img-provider lazyload"
                                  />
                                </template>
                              </picture>
                              <div class="-menu-text">{{ $t('menu_labels.roulette') }}</div>
                            </router-link>
                          </li>
                          <li
                            class="nav-item -random-container -game-slot-macro-container  lucky-tile lucky-tile-gashapon"
                          >
                            <router-link aria-label="กาชาปอง" to="/gashapon" class="nav-link js-account-approve-aware">
                              <picture>
                                <template v-if="gashapon">
                                  <img
                                    src="../assets/images/menu/mobile-menu-gashapon.webp"
                                    alt="กาชาปอง time2lucky คาสิโน บาคาร่าสดออนไลน์"
                                    class="animate__animated animate__pulse animate__infinite img-fluid -img-provider lazyload"
                                  />
                                </template>
                                <template v-else>
                                  <img
                                    src="../assets/images/menu/mobile-menu-gashapon.webp"
                                    alt="กาชาปอง time2lucky คาสิโน บาคาร่าสดออนไลน์"
                                    class="img-fluid -img-provider lazyload"
                                  />
                                </template>
                              </picture>
                              <div class="-menu-text">{{ $t('menu_labels.gashapon') }}</div>
                            </router-link>
                          </li>
                          <li
                            class="nav-item -random-container -game-slot-macro-container  lucky-tile lucky-tile-huay"
                          >
                            <router-link aria-label="แทงหวย" to="/huay" class="nav-link js-account-approve-aware">
                              <picture>
                                <template v-if="huay">
                                  <img
                                    src="../assets/images/menu/mobile-menu-huay.webp"
                                    alt="แทงหวย time2lucky คาสิโน บาคาร่าสดออนไลน์"
                                    class="animate__animated animate__pulse animate__infinite img-fluid -img-provider lazyload"
                                  />
                                </template>
                                <template v-else>
                                  <img
                                    src="../assets/images/menu/mobile-menu-huay.webp"
                                    alt="แทงหวย time2lucky คาสิโน บาคาร่าสดออนไลน์"
                                    class="img-fluid -img-provider lazyload"
                                  />
                                </template>
                              </picture>
                              <div class="-menu-text">{{ $t('menu_labels.lottery') }}</div>
                            </router-link>
                          </li>
                          <li
                            class="nav-item -random-container -game-slot-macro-container  lucky-tile lucky-tile-rewards"
                          >
                            <router-link aria-label="แลกของรางวัล" to="/rewards" class="nav-link js-account-approve-aware">
                              <picture>
                                <template>
                                  <img
                                    src="../assets/images/menu/mobile-menu-rewards.webp"
                                    alt="แลกของรางวัล time2lucky คาสิโน บาคาร่าสดออนไลน์"
                                    class="img-fluid -img-provider lazyload"
                                  />
                                </template>
                              </picture>
                              <div class="-menu-text">{{ $t('menu_labels.rewards') }}</div>
                            </router-link>
                          </li>
                          <!-- <li
                            class="nav-item -random-container -game-slot-macro-container "
                          >
                            <a
                              href="/_ajax_/random?randomCategory=skill-game"
                              class="nav-link js-account-approve-aware"
                              target="_blank"
                              rel="nofollow noopener"
                            >
                              <picture>
                                <img
                                  src="../assets/images/menu/mobile-menu-rewards.webp"
                                  alt="สุ่มเล่นสกิลเกมบนเว็บ time2lucky คาสิโน บาคาร่าสดออนไลน์"
                                  class="img-fluid -img-provider lazyload"
                                />
                              </picture>
                            </a>
                          </li> -->
                          <!-- <li class="nav-item -random-container -game-slot-macro-container">
                            <div
                              class="x-game-list-item-macro js-game-list-toggle -big "
                              data-status=""
                            >
                              <div class="-inner-wrapper">
                                <picture>
                                  <img
                                    class="img-fluid lazyload"
                                    alt="E.t. Races | wt-evo-play สกิลเกมในเว็บคาสิโนออนไลน์ รับเครดิตฟรีที่ time2lucky"
                                    src="../assets/images/menu/mobile-menu-history.webp"
                                  />
                                </picture>

                               <div class="-overlay">
                                  <div class="-overlay-inner">
                                    <div class="-wrapper-container">
                                      <a
                                        href="/account/lobby/play?channelCode=wt-evo-play&amp;metadata%5Bgame_id%5D=1012"
                                        class="-btn -btn-play js-account-approve-aware"
                                        target="_blank"
                                        rel="nofollow noopener"
                                      >
                                        <i class="fas fa-play"></i>
                                        <span class="-text-btn">เข้าเล่น</span>
                                      </a>
                                      <a
                                        href="/lobby/test?channelCode=wt-evo-play&amp;metadata%5Bgame_id%5D=1012"
                                        class="-btn -btn-demo"
                                        target="_blank"
                                        rel="noopener"
                                      >
                                        ทดลองเล่น
                                      </a>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </li> -->
                        </ul>
                      </nav>
              <DailyLoopHub
                v-if="qilinStatus && qilinStatus.enabled"
                :pet="qilinStatus.pet"
                :checkin="qilinStatus.checkin"
                :missions="qilinStatus.missions"
              />
              <div class="lucky-home-introduction">
                <img
                  src="../assets/images/time2lucky-introduction.png"
                  alt="Time2lucky เว็บชั้นนำอันดับ 1 ของประเทศ"
                  width="1700"
                  height="900"
                  loading="lazy"
                  decoding="async"
                />
              </div>
                    </div>

                                        
                  </div>
                </div>
              </div>



              <div
                class="-live-feed-wrapper-container js-replace-live-feed-wrapper"
              ></div>
            </div>
          </section>

          <footerSection></footerSection>
        </div>
      </div>

      <div class="x-right-sidebar-container"></div>

      <div
        class="x-modal modal  "
        id="ads-no-show-again"
        tabindex="-1"
        role="dialog"
        aria-hidden="true"
        data-loading-container=".js-modal-content"
        data-ajax-modal-always-reload="true"
        data-modal-one-time="Announcement Banner 1"
        data-check-target="#ads-no-show-again"
      >
        <div class="modal-dialog -modal-size " role="document">
          <div class="modal-content -modal-content">
            <button
              type="button"
              class="close f-1 "
              data-dismiss="modal"
              aria-label="Close"
            >
              <i class="fas fa-times"></i>
            </button>
            <div class="modal-header -modal-header">
              <h3 class="x-title-modal d-inline-block m-auto">
                <span>📢 ประกาศสำคัญ</span>
              </h3>
            </div>
            <div class="modal-body -modal-body">
              <div class="text-center" v-if="anoucement.image">
                <img
                  :src="anoucement.image"
                  alt="Announcement time2lucky"
                  class="img-fluid"
                  width="350px"
                />
              </div>
              <br>
              <div v-html="nl2br(anoucement.detail)" style="font-size:15px;font-family: 'Kanit', sans-serif;"></div>
              <div class="x-checkbox-primary">
                <div class="text-primary text-center mt-4">
                  <input
                    type="checkbox" v-model="receiveAnounceMent"
                  />&nbsp;&nbsp;&nbsp;&nbsp;
                  <label style="font-size:14px;font-family: 'Kanit', sans-serif;">
                    ไม่ต้องแสดงข้อความนี้อีก
                  </label>
                </div>
              </div>

              <div class="my-3">
                <a
                  @click="submitAnoucement()"
                  data-dismiss="modal"
                  class="text-black btn btn-block -submit btn-primary text-center m-auto"
                >
                  <span>ปิดข้ามไปก่อน</span>
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="admin-tip-overlay" v-if="adminTipPopup" @click.self="closeAdminTipPopup">
        <div class="admin-tip-modal">
          <button type="button" class="admin-tip-close" @click="closeAdminTipPopup">
            <i class="fas fa-times"></i>
          </button>
          <div class="admin-tip-header">
            <h3>ทิปแอดมิน</h3>
            <p>ยอดที่ใช้ทิปได้ {{ numberWithCommas(adminTip.available) }} บาท</p>
          </div>

          <div v-if="adminTip.loading" class="admin-tip-loading">
            <i class="fa fa-spinner fa-spin"></i>
            <span>กำลังโหลดข้อมูล...</span>
          </div>

          <div v-else>
            <label class="admin-tip-label">เลือกแอดมิน</label>
            <select class="admin-tip-input" v-model="adminTip.selectedAdminKey">
              <option value="" disabled>เลือกแอดมินที่ต้องการให้ทิป</option>
              <option v-for="admin in adminTip.admins" :key="admin.key" :value="admin.key">
                {{ admin.tip_nickname }}
              </option>
            </select>

            <label class="admin-tip-label">จำนวนเงิน</label>
            <div class="admin-tip-amounts">
              <button
                v-for="amount in adminTip.amounts"
                :key="amount"
                type="button"
                :class="{ active: Number(adminTip.amount) === Number(amount) }"
                @click="adminTip.amount = amount"
              >
                {{ amount.toLocaleString() }}
              </button>
            </div>
            <input
              class="admin-tip-input"
              type="number"
              :min="adminTipMinAmount"
              step="1"
              v-model.number="adminTip.amount"
              :placeholder="`หรือกรอกจำนวนเงิน ขั้นต่ำ ${adminTipMinAmount} บาท`"
            />

            <label class="admin-tip-label">เหตุผล</label>
            <div class="admin-tip-reasons">
              <button
                v-for="reason in adminTip.reasons"
                :key="reason"
                type="button"
                :class="{ active: adminTip.reasonPreset === reason }"
                @click="adminTip.reasonPreset = reason"
              >
                {{ reason }}
              </button>
            </div>
            <textarea
              class="admin-tip-input admin-tip-textarea"
              maxlength="200"
              v-model="adminTip.reasonText"
              placeholder="พิมพ์เหตุผลเพิ่มเติม"
            ></textarea>

            <div v-if="adminTip.error" class="admin-tip-error">
              {{ adminTip.error }}
            </div>

            <button
              type="button"
              class="admin-tip-submit"
              :disabled="!canSubmitAdminTip"
              @click="submitAdminTip"
            >
              <span v-if="adminTip.submitting"><i class="fa fa-spinner fa-spin"></i> กำลังทำรายการ...</span>
              <span v-else>ยืนยันให้ทิป</span>
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
/* global $ */
import router from './../router'
import firebase from 'firebase/app'
import 'firebase/functions'
import moment from 'moment-timezone'
import qilinApi from '../services/qilinRetention'
export default {
  name: 'Home',
  components: {
    DailyLoopHub: () => import('../components/qilin/DailyLoopHub.vue'),
    headerSection: () => import('./Header.vue'),
    footerSection: () => import('./Footer.vue')
  },
  async mounted () {
    this.$store.dispatch('user/getBanners').catch(err => { console.error(err) })
    const user = this.getUserId()
    if (!user || !user.key) return
    this.loadQilinHomeStatus()
    this.checkAnoucement(user)
    await this.checkDeposit(user)
    this.checkSpin(user)
    this.checkRoulet(user)
    this.checkCashback(user)
    this.checkPartner(user)
    this.checkGashapon(user)
    this.fetchAdminTipVisibility(user)
    if (user.key) {
      firebase.database().ref(`/users/${user.key}/disablepro/continue`).once('value', (snapshot) => {
        if (snapshot.val() === false) {
          this.disablecontinue = true
        } else {
          this.checkContinue(user)
        }
      })
    }
    if (Number(moment().tz('Asia/Bangkok').format('D')) === 1 || Number(moment().tz('Asia/Bangkok').format('D')) === 16) {
      if (Number(moment().tz('Asia/Bangkok').format('H') + '' + moment().tz('Asia/Bangkok').format('mm')) <= 1520) {
        this.checkHuay()
      }
    }
    // Snackbar.show({pos: 'top-center',text: 'Example notification text.',actionText:'Click',actionTextColor:'#ffd74c',backgroundColor:'#47124A'});
  },
  beforeRouteLeave (to, from, next) {
    this.cleanupAnnouncementModal()
    next()
  },
  beforeDestroy () {
    this.cleanupAnnouncementModal()
  },
  computed: {
    banners () {
      return this.$store.state.user.banners
    },
    swiper () {
      return this.$refs.mySwiper.$swiper
    },
    lastbonus () {
      return this.$store.state.user.lastbonus
    },
    canSubmitAdminTip () {
      return !this.adminTip.loading &&
        !this.adminTip.submitting &&
        this.adminTip.tip === true &&
        this.adminTip.selectedAdminKey &&
        Number(this.adminTip.amount) >= this.adminTipMinAmount &&
        Number(this.adminTip.amount) <= Number(this.adminTip.available) &&
        (this.adminTip.reasonPreset || this.adminTip.reasonText.trim())
    }
  },
  data () {
    return {
      qilinStatus: null,
      cashback_yesterday: 0,
      deposit: 0,
      disablecontinue: false,
      continueCheck: false,
      partner: false,
      cashback: false,
      roulet: false,
      spin: false,
      huay: false,
      gashapon: false,
      receiveAnounceMent: false,
      anoucement: {},
      user: {},
      balance: 0,
      fa_spin: false,
      adminTipMinAmount: 1,
      adminTipPopup: false,
      adminTip: {
        enabled: false,
        loading: false,
        submitting: false,
        admins: [],
        amounts: [],
        reasons: [],
        selectedAdminKey: '',
        amount: '',
        reasonPreset: '',
        reasonText: '',
        tip: false,
        available: 0,
        error: ''
      },
      swiperOptions: {
        loop: true,
        speed: 2000,
        slidesPerView: 2,
        autoplay: {
          delay: 2000,
          disableOnInteraction: false
        },
        breakpoints: {
          1024: {
            slidesPerView: 2,
            spaceBetween: 40
          },
          768: {
            slidesPerView: 2,
            spaceBetween: 30
          },
          640: {
            slidesPerView: 1,
            spaceBetween: 20
          },
          320: {
            slidesPerView: 1,
            spaceBetween: 10
          }
        },
        centeredSlides: true,
        spaceBetween: 40,
        grabCursor: true,
        pagination: {
          el: '.swiper-pagination'
        }
        // Some Swiper option/callback...
      }
    }
  },
  methods: {
    async loadQilinHomeStatus () {
      try {
        const status = await qilinApi.getHomeStatus()
        this.qilinStatus = status && status.enabled ? status : null
      } catch (error) {
        this.qilinStatus = null
        if (process.env.NODE_ENV === 'development') console.warn('Qilin home status unavailable', error)
      }
    },
    cleanupAnnouncementModal () {
      const modal = $('#ads-no-show-again')
      if (modal && modal.length) {
        modal.modal('hide')
        modal.removeClass('show')
        modal.css('display', 'none')
        modal.attr('aria-hidden', 'true')
        modal.removeAttr('aria-modal')
      }
      $('.modal-backdrop').remove()
      $('body').removeClass('modal-open').css('padding-right', '').css('overflow', '')
    },
    getUserId () {
      const user = localStorage.getItem('userData')
      if (user) {
        try {
          const _user = JSON.parse(user)
          if (_user && _user.key) return _user
        } catch (error) {
          console.error(error)
        }
      }
      this.cleanupAnnouncementModal()
      firebase.auth().signOut().catch(err => { console.error(err) })
      localStorage.removeItem('userData')
      if (this.$route.path !== '/login') router.replace('/login')
      return null
    },
    nl2br (str, is_xhtml) {
      if (typeof str === 'undefined' || str === null) {
        return ''
      }
      var breakTag = (is_xhtml || typeof is_xhtml === 'undefined') ? '<br />' : '<br>'
      return (str + '').replace(/([^>\r\n]?)(\r\n|\n\r|\r|\n)/g, '$1' + breakTag + '$2')
    },
    numberWithCommas (x) {
      return Number(x || 0).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',')
    },
    createAdminTipIdempotencyKey () {
      const user = this.getUserId()
      return `admin-tip-${user.key}-${Date.now()}-${Math.random().toString(36).substring(2, 10)}`
    },
    orderAdminTipAdmins (admins) {
      const list = Array.isArray(admins) ? admins.slice() : []
      const pooledTipAdmins = []
      const otherAdmins = []

      list.forEach((admin) => {
        const nickname = (admin && (admin.tip_nickname || admin.nickname) ? (admin.tip_nickname || admin.nickname) : '').toString().trim()
        if (nickname.includes('ทิปรวม')) pooledTipAdmins.push(admin)
        else otherAdmins.push(admin)
      })

      for (let index = otherAdmins.length - 1; index > 0; index--) {
        const randomIndex = Math.floor(Math.random() * (index + 1))
        const current = otherAdmins[index]
        otherAdmins[index] = otherAdmins[randomIndex]
        otherAdmins[randomIndex] = current
      }

      return pooledTipAdmins.concat(otherAdmins)
    },
    async fetchAdminTipVisibility (user) {
      if (!user || !user.key) return
      try {
        const getAdminTipBootstrap = firebase.app().functions('asia-east2').httpsCallable('getAdminTipBootstrap')
        const result = await getAdminTipBootstrap({
          user_key: user.key,
          keygen: user.keygen || ''
        })
        const data = result.data || {}
        this.adminTip.enabled = data.enabled !== false
      } catch (error) {
        console.error(error)
        this.adminTip.enabled = false
      }
    },
    async openAdminTipPopup () {
      this.adminTip.loading = true
      this.adminTip.selectedAdminKey = ''
      this.adminTip.amount = ''
      this.adminTip.reasonPreset = ''
      this.adminTip.reasonText = ''
      this.adminTip.tip = false
      this.adminTip.error = ''
      try {
        const user = this.getUserId()
        const getAdminTipBootstrap = firebase.app().functions('asia-east2').httpsCallable('getAdminTipBootstrap')
        const result = await getAdminTipBootstrap({
          user_key: user.key,
          keygen: user.keygen || ''
        })
        const data = result.data || {}
        if (data.enabled === false) {
          this.adminTip.enabled = false
          this.adminTipPopup = false
          return
        }
        this.adminTip.enabled = true
        this.adminTip.admins = this.orderAdminTipAdmins(data.admins || [])
        this.adminTip.amounts = data.amounts || []
        this.adminTip.reasons = data.reasons || []
        this.adminTip.tip = data.tip === true
        this.adminTip.available = Number(data.available_credit || 0)
        if (this.adminTip.reasons.length) this.adminTip.reasonPreset = this.adminTip.reasons[0]
        if (this.adminTip.tip !== true) {
          const blockedMessage = data.blocked_message || 'เครดิตล่าสุดไม่สามารถใช้ให้ทิปได้'
          this.adminTip.error = blockedMessage
          this.$swal({ icon: 'error', title: 'ทิปแอดมิน', text: blockedMessage })
          return
        }

        const introResult = await this.$swal({
          icon: 'info',
          title: 'ทิปแอดมิน',
          html: 'ประทับใจการให้บริการของแอดมิน<br>กดส่งทิปเป็นกำลังใจให้น้องๆ ได้ค่ะ<br><br>ทิปที่ให้ จะหักออกจากเครดิตของลูกค้า<br>และไม่สามารถยกเลิกหรือคืนเงินได้นะคะ',
          confirmButtonText: 'ตกลง',
          allowOutsideClick: false,
          allowEscapeKey: false
        })
        if (introResult && introResult.dismiss) return

        this.adminTipPopup = true
      } catch (error) {
        console.error(error)
        this.$swal({ icon: 'error', title: 'เกิดข้อผิดพลาด', text: error.message || 'ไม่สามารถโหลดข้อมูลทิปแอดมินได้' })
        this.adminTipPopup = false
      } finally {
        this.adminTip.loading = false
      }
    },
    closeAdminTipPopup () {
      if (this.adminTip.submitting) return
      this.adminTipPopup = false
    },
    forceCloseAdminTipPopup () {
      this.adminTipPopup = false
    },
    async submitAdminTip () {
      if (!this.canSubmitAdminTip) return
      this.adminTipPopup = false
      await this.$nextTick()
      const confirmResult = await this.$swal({
        icon: 'warning',
        title: 'ยืนยันการให้ทิปแอดมิน',
        showCancelButton: true,
        confirmButtonText: 'ยืนยัน',
        cancelButtonText: 'ยกเลิก',
        reverseButtons: false
      })
      if (!confirmResult || (!confirmResult.isConfirmed && confirmResult.value !== true)) {
        this.adminTipPopup = true
        return
      }

      this.adminTip.submitting = true
      this.adminTip.error = ''
      try {
        const user = this.getUserId()
        const submitAdminTip = firebase.app().functions('asia-east2').httpsCallable('submitAdminTip')
        const result = await submitAdminTip({
          user_key: user.key,
          keygen: user.keygen || '',
          admin_key: this.adminTip.selectedAdminKey,
          amount: Math.floor(Number(this.adminTip.amount)),
          reason_preset: this.adminTip.reasonPreset,
          reason_text: this.adminTip.reasonText,
          idempotency_key: this.createAdminTipIdempotencyKey()
        })
        const data = result.data || {}
        this.adminTip.tip = data.tip === true
        this.adminTip.available = Number(data.available_credit || 0)
        this.$store.dispatch('user/setUser', user).catch(err => { console.error(err) })
        this.forceCloseAdminTipPopup()
        this.$swal({ icon: 'success', title: 'สำเร็จ', text: `ให้ทิปแอดมิน ${Number(data.amount || this.adminTip.amount).toLocaleString()} บาท สำเร็จ` })
      } catch (error) {
        console.error(error)
        this.adminTip.error = error.message || 'ไม่สามารถทำรายการทิปได้'
        await this.$swal({ icon: 'error', title: 'เกิดข้อผิดพลาด', text: error.message || 'ไม่สามารถทำรายการทิปได้' })
        this.adminTipPopup = true
      } finally {
        this.adminTip.submitting = false
      }
    },
    // async moveCreditToWallet () {
    //   this.$store.commit('user/SET_LOADING', true)
    //   const user = this.getUserId()
		//   this.$store.dispatch('user/moveCreditToWallet').catch(err => { console.error(err) })
    //   this.$store.dispatch('user/getLastBonus', user).finally(res => {
    //     this.$store.commit('user/SET_LOADING', false)
    //     if (this.lastbonus.turncredit) {
    //       this.$store.commit('user/SET_ALERT_WITHDRAWALL', true)
    //     }
    //   }).catch(err => { console.error(err) })
	  // },
    async checkDeposit (currentUser) {
      const user = currentUser || this.getUserId()
      if (!user || !user.key) return
      let deposit = 0
      await firebase.firestore().collection('history').where('userkey', '==', user.key).where('type', '==', 'ฝาก').where('status', '==', 'ดำเนินการแล้ว').where('createdate', '>=', moment().tz('Asia/Bangkok').format('YYYY-MM-DD') + ' 00:00:00').where('createdate', '<=', moment().tz('Asia/Bangkok').format('YYYY-MM-DD') + ' 23:59:59').get().then(async (snapshot) => {
        snapshot.forEach((doc) => {
          deposit += Number(doc.data().qty)
        })
      })
      this.deposit = deposit
    },
    async checkCashbackYesterday (currentUser) {
      const user = currentUser || this.getUserId()
      if (!user || !user.key) return
      await firebase.firestore().collection('daily_deposit').doc(user.key + '-' + moment().tz('Asia/Bangkok').add(-1, 'days').format('YYYY-MM-DD')).get().then(async (doc) => {
        if (doc.exists) {
          this.cashback_yesterday = doc.data().cashback
        }
      })
    },
    async checkPromotions () {
      this.$store.commit('user/SET_LOADING', true)
      this.$store.dispatch('user/checkPromotions').finally(res => { this.$store.commit('user/SET_LOADING', false) }).catch(err => { console.error(err) })
    },
    async fetchGeneralAnnouncement () {
      const ref = firebase.database().ref('/anoucement/1')
      const [detailSnapshot, imageSnapshot, nameSnapshot, statusSnapshot] = await Promise.all([
        ref.child('detail').once('value'),
        ref.child('image').once('value'),
        ref.child('name').once('value'),
        ref.child('status').once('value')
      ])

      return {
        detail: detailSnapshot.val() || '',
        image: imageSnapshot.val() || '',
        name: nameSnapshot.val() || 'anouncement',
        status: statusSnapshot.val() === true
      }
    },
    async hasSeenGeneralAnnouncement (userKey) {
      const db = firebase.database()
      const [seenSnapshot, legacySeenSnapshot] = await Promise.all([
        db.ref(`/anoucement_seen/1/${userKey}`).once('value'),
        db.ref(`/anoucement/1/users/${userKey}`).once('value')
      ])

      if (legacySeenSnapshot.val() && !seenSnapshot.val()) {
        db.ref(`/anoucement_seen/1/${userKey}`).set(true).catch(err => { console.error(err) })
      }

      return seenSnapshot.val() === true || legacySeenSnapshot.val() === true
    },
    async checkAnoucement (currentUser) {
      const user = currentUser || this.getUserId()
      if (!user || !user.key) return
      const [anoucement, hasSeen] = await Promise.all([
        this.fetchGeneralAnnouncement(),
        this.hasSeenGeneralAnnouncement(user.key)
      ])
      if (this.$route.name !== 'Home' || !firebase.auth().currentUser) return
      const activeUser = this.getUserId()
      if (!activeUser || activeUser.key !== user.key) return
      if (anoucement && anoucement.status) {
        if (!hasSeen) {
          this.anoucement = anoucement
          this.$nextTick(() => {
            if (this.$route.name === 'Home') $('#ads-no-show-again').modal('show')
          })
        }
      }
    },
    checkSpin (currentUser) {
      const user = currentUser || this.getUserId()
      if (!user || !user.key) return
      if (this.deposit >= 500) {
        firebase.firestore().collection('spin').doc(user.key + '-' + moment().tz('Asia/Bangkok').format('YYYY-MM-DD')).get().then(async (snapshot) => {
          if (!snapshot.exists) {
            this.spin = true
          }
        })
      }
    },
    checkRoulet (currentUser) {
      const user = currentUser || this.getUserId()
      if (!user || !user.key) return
      if (this.deposit >= 1000) {
        firebase.firestore().collection('roulet').doc(user.key + '-' + moment().tz('Asia/Bangkok').format('YYYY-MM-DD')).get().then(async (snapshot) => {
          if (!snapshot.exists) {
            this.roulet = true
          }
        })
      }
    },
    checkHuay () {
      if (this.deposit >= 200) {
        this.huay = true
      }
    },
    checkGashapon (currentUser) {
      const user = currentUser || this.getUserId()
      if (!user || !user.key) return
      if (this.deposit >= 100) {
        firebase.firestore().collection('spin').doc(user.key + '-' + moment().tz('Asia/Bangkok').format('YYYY-MM-DD') + '-gashapon').get().then(async (snapshot) => {
          if (!snapshot.exists) {
            this.gashapon = true
          }
        })
      }
    },
    checkCashback (currentUser) {
      const user = currentUser || this.getUserId()
      if (!user || !user.key) return
      firebase.firestore().collection('cashback').where('date', '==', moment().tz('Asia/Bangkok').format('YYYY-MM-DD')).where('userkey', '==', user.key).where('status', '==', false).get().then((snapshot) => {
        if (snapshot.size) this.cashback = true
      })
    },
    checkPartner (currentUser) {
      const user = currentUser || this.getUserId()
      if (!user || !user.key) return
      firebase.firestore().collection('partner').where('date', '==', moment().tz('Asia/Bangkok').format('YYYY-MM-DD')).where('userkey', '==', user.key).where('status', '==', false).get().then((snapshot) => {
        if (snapshot.size) this.partner = true
      })
    },
    checkContinue (currentUser) {
      const user = currentUser || this.getUserId()
      if (!user || !user.key) return
      firebase.firestore().collection('continuous_deposit').where('date', '==', moment().tz('Asia/Bangkok').add(-1, 'days').format('YYYY-MM-DD')).where('userkey', '==', user.key).where('status', '==', false).get().then((snapshot) => {
        if (snapshot.size) this.continueCheck = true
      })
    },
    submitAnoucement () {
      if (this.receiveAnounceMent) {
        const user = this.getUserId()
        if (!user || !user.key) return
        firebase.database().ref(`/anoucement_seen/1/${user.key}`).set(true)
      }
    }
  }
}
</script>
<style scoped>
.lucky-home-banner-slide {
  display: flex;
  align-items: center;
  justify-content: center;
}

.lucky-home-banner-image {
  display: block;
  width: 100%;
  max-width: 650px;
  margin: auto;
  border-radius: 15px;
  aspect-ratio: 800 / 288;
  object-fit: cover;
}

@media (min-width: 1024px) {
  .lucky-home-banner-slide {
    flex: 0 0 calc((100% - 40px) / 2) !important;
    width: calc((100% - 40px) / 2) !important;
    margin-right: 40px !important;
  }

  .lucky-home-banner-image {
    max-width: 900px;
  }
}

.x-modal .-modal-content .-modal-body {
     top: 10px;
}
@media (max-width: 575.98px) {
  .x-modal .-modal-content .-modal-body {
     top: 90px;
  }
}

/* Menu Text Labels */
.-menu-text {
  text-align: center;
  font-family: 'Poppins', 'Kanit', 'Montserrat', Arial, sans-serif;
  font-size: 18px;
  font-weight: 700;
  color: #ffd700;
  margin-top: 10px;
  letter-spacing: 0.5px;
  text-shadow: 2px 2px 8px rgba(80, 0, 80, 0.25), 0 1px 0 #fff;
  border-radius: 8px;
  background: rgba(40, 0, 60, 0.15);
  padding: 2px 0 0 0;
  transition: color 0.2s, background 0.2s;
}
.-menu-text:hover {
  color: #fff;
  background: linear-gradient(90deg, #ffed4e 0%, #ffd700 100%);
  text-shadow: 2px 2px 8px rgba(80, 0, 80, 0.35), 0 1px 0 #fff;
}

.admin-tip-floating-button {
  position: fixed;
  right: 0;
  top: 255px;
  z-index: 7;
  min-width: 58px;
  min-height: 58px;
  border: 0;
  border-top-left-radius: 18px;
  border-bottom-left-radius: 18px;
  background: linear-gradient(180deg, #f7d95a 0%, #7020aa 100%);
  color: #190625;
  box-shadow: 0 5px 18px rgba(112, 32, 170, 0.28), 0 8px 24px rgba(0, 0, 0, 0.36);
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  font-family: Kanit, Helvetica Neue, Helvetica, Arial, sans-serif;
  font-size: 13px;
  font-weight: 800;
  line-height: 1;
}

.admin-tip-floating-button i {
  font-size: 19px;
  margin-bottom: 5px;
}

.admin-tip-floating-button:focus {
  outline: none;
}

.admin-tip-floating-button:hover {
  color: #111;
  filter: brightness(1.05);
}

.admin-tip-overlay {
  position: fixed;
  z-index: 9999;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.72);
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 18px;
}

.admin-tip-modal {
  position: relative;
  width: 100%;
  max-width: 440px;
  max-height: 92vh;
  overflow-y: auto;
  background: linear-gradient(180deg, rgba(12, 45, 18, 0.98) 0%, rgba(5, 12, 6, 0.98) 52%, rgba(14, 34, 11, 0.98) 100%);
  border: 2px solid #d8c06a;
  border-radius: 18px;
  padding: 24px;
  color: #fff;
  box-shadow: 0 12px 44px rgba(0, 0, 0, 0.58), inset 0 0 0 1px rgba(142, 255, 149, 0.12);
}

.admin-tip-close {
  position: absolute;
  top: 12px;
  right: 12px;
  width: 34px;
  height: 34px;
  border: 0;
  border-radius: 50%;
  background: rgba(0, 0, 0, 0.48);
  color: #fff;
}

.admin-tip-header {
  text-align: center;
  margin-bottom: 18px;
}

.admin-tip-header h3 {
  color: #f2d564;
  font-weight: 800;
  margin-bottom: 6px;
}

.admin-tip-header p {
  margin: 0;
  color: rgba(255, 255, 255, 0.86);
}

.admin-tip-loading {
  min-height: 120px;
  display: flex;
  gap: 10px;
  align-items: center;
  justify-content: center;
}

.admin-tip-label {
  display: block;
  margin: 14px 0 8px;
  font-weight: 700;
  color: #fbc844;
}

.admin-tip-input {
  width: 100%;
  min-height: 44px;
  border: 1px solid rgba(216, 192, 106, 0.68);
  border-radius: 10px;
  padding: 10px 12px;
  background: rgba(0, 0, 0, 0.48);
  color: #fff;
  font-size: 15px;
}

.admin-tip-input::placeholder {
  color: rgba(242, 213, 100, 0.5);
}

.admin-tip-input:focus {
  outline: none;
  border-color: #f7d95a;
  box-shadow: 0 0 0 3px rgba(112, 32, 170, 0.18);
}

.admin-tip-input option {
  color: #000;
}

.admin-tip-textarea {
  min-height: 86px;
  resize: vertical;
}

.admin-tip-amounts,
.admin-tip-reasons {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  margin-bottom: 10px;
}

.admin-tip-amounts button,
.admin-tip-reasons button {
  border: 1px solid rgba(216, 192, 106, 0.7);
  border-radius: 999px;
  background: rgba(112, 32, 170, 0.12);
  color: #fff;
  padding: 8px 14px;
  font-weight: 700;
}

.admin-tip-amounts button.active,
.admin-tip-reasons button.active {
  background: linear-gradient(180deg, #f7d95a 0%, #7020aa 100%);
  color: #190625;
}

.admin-tip-submit {
  width: 100%;
  margin-top: 18px;
  min-height: 48px;
  border: 0;
  border-radius: 12px;
  background: linear-gradient(180deg, #f7d95a 0%, #7020aa 100%);
  color: #190625;
  font-size: 17px;
  font-weight: 800;
}

.admin-tip-submit:disabled {
  opacity: 0.55;
  cursor: not-allowed;
}

.admin-tip-error {
  margin-top: 12px;
  padding: 10px 12px;
  border: 1px solid rgba(255, 88, 88, 0.55);
  border-radius: 10px;
  background: rgba(88, 0, 0, 0.38);
  color: #fff;
  font-size: 14px;
  line-height: 1.45;
}

@media (max-width: 768px) {
  .admin-tip-floating-button {
    top: 250px;
    min-width: 54px;
    min-height: 54px;
    font-size: 12px;
  }

  .-menu-text {
    font-size: 15px;
    margin-top: 7px;
  }
}
@media (max-width: 480px) {
  .-menu-text {
    font-size: 13px;
    margin-top: 4px;
  }
}
</style>
